import React, { useState, Suspense, useRef } from 'react';
import SmsForm from 'features/crm/components/notification-templates/SmsForm';
import SmsList from 'features/crm/components/notification-templates/SmsList';
import Tooltip from 'shared/ui/Tooltip';
import Loading from 'shared/ui/Loading';
import { useLayout } from 'shared/contexts/LayoutContext';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { Info } from 'lucide-react';




const Smss = () => {
  const { currentColor } = useStateContext();
  const { openModal } = useLayout();
  const listRef = useRef(null);

  const handleRefreshList = () => {
    listRef.current?.refresh();
  };

  const handleAddSms = () => {
    openModal({
      component: <SmsForm refreshList={handleRefreshList} />,
      title: 'Добавить рассылку',
    });
  };
  return (
    <>
      <Suspense fallback={<Loading/>}>

      <div className='bg-gray-100 py-4 px-6 flex justify-between items-center relative'>
        <div className='flex items-center relative'>
          <Tooltip content={'Here will be related info'} trigger='click' className='mr-2'>
            <button className='text-gray-700 hover:text-gray-900 mr-2 mt-1'>
              <Info size={20} />
            </button>
          </Tooltip>
          <h1 className='text-2xl font-bold'>Рассылки</h1>
          
        </div>
        <div className='flex items-center'>
          <button className=' text-white px-4 py-2 rounded-md hover:' style={{ backgroundColor: currentColor }} onClick={() => handleAddSms()}>
            + Рассылка
          </button>
        </div>
      </div>
        
        <SmsList ref={listRef} />
      </Suspense>
    </>
  );
};

export default Smss;
